// extracted by mini-css-extract-plugin
export default {"centeredKeyboard":"AddingIrregularityProcessView_centeredKeyboard__hf8mX"};